import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  /**
   * Custom pattern validator that accepts a pattern and error message
   * @param pattern - The regex pattern to validate against
   * @param errorMessage - The error message to display when validation fails
   * @returns A validator function
   */
  static pattern(pattern: RegExp | string, errorMessage: string = 'Invalid pattern'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      try {
        const regex = typeof pattern === 'string' ? new RegExp(pattern) : pattern;
        const valid = regex.test(control.value);
        return valid ? null : { pattern: { message: errorMessage } };
      } catch (error) {
        console.error('Invalid pattern provided to CustomValidators.pattern:', error);
        return { pattern: { message: 'Invalid validation pattern' } };
      }
    };
  }
} 